import dayjs from 'dayjs';

export const getTimeStringFromTimestamps = (
  startTime: number,
  endTime: number,
  format?: string,
  separator?: string
) => {
  const start = dayjs(startTime).format(format || 'HH:mm');
  const end = dayjs(endTime).format(format || 'HH:mm');
  return separator ? `${start}${separator}${end}` : `${start} - ${end}`;
};
